import React from 'react'
import { Flex, Pane, Popup, TableV2, Text } from '@leverege/ui-elements'

import useTrafficTable from '../hooks/useTrafficTable'
import ChartTypeSelector from '../../aisleHeatmapping/ChartTypeSelector'

import S from './TrafficTable.css'

export default function TrafficTable( props ) {
  const { className } = props
  const { data, columns, type, onChangeType } = useTrafficTable( props )

  return (
    <Pane variant="cardNoPad" layout="flex:col" className={className}>
      <div style={{
        height : '60px',
        padding : 'var(--size-padLarge)',
        borderBottom : '1px solid var(--color-base100)'
      }}>
        <Flex variant="rowSpaceBetween">
          <Text variant="subtitle">Power Hours</Text>
          <Flex variant="rowMCenter">
            <Key />
            <ChartTypeSelector value={type} onChange={onChangeType} />
          </Flex>
        </Flex>
      </div>
      <div style={{
        height : 'calc(100% - 60px)',
        // padding : '0 var(--size-padLarge) var(--size-padLarge) var(--size-padLarge)'
      }}>
        <TableV2
          className={S.table}
          variant="traffic"
          data={data}
          columns={columns} />
      </div>
    </Pane>
  )
}

function Key( props ) {
  return (
    <Popup variant="trafficTableKey" title="Key" icon="fa fa-fw fa-info-circle">
      <Pane variant="trafficTableKey">
        <Flex variant="colL">
          <Flex variant="rowSpaceBetween">
            <Text variant="keyLabel">People</Text>
            <Flex variant="rowS">
              <Text variant="pillPerson">{'1.2% <= Traffic <= 1.5%'}</Text>
              <Text variant="pillPersonDark">{'Traffic > 1.5%'}</Text>
            </Flex>
          </Flex>
          <Flex variant="rowSpaceBetween">
            <Text variant="keyLabel">Dogs</Text>
            <Flex variant="rowS">
              <Text variant="pillDog">{'1.2% <= Traffic <= 1.5%'}</Text>
              <Text variant="pillDogDark">{'Traffic > 1.5%'}</Text>
            </Flex>
          </Flex>
        </Flex>
      </Pane>
    </Popup>
  )
}
